import api from '../../api/client';
import React, { useEffect, useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import config from "../../config";
import axios from "axios";

const FeedReport = () => {
  const [feedOptions, setFeedOptions] = useState([]);
  const [farmOptions, setFarmOptions] = useState([]);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [selectedFarm, setSelectedFarm] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    const fetchOptions = async () => {
      const feedRes = await api.get(`/feeds`);
      const farmRes = await api.get(`/farm`);

      const feeds = feedRes.data;
      const farms = farmRes.data;

      setFeedOptions(
        feeds.map((f) => ({ label: f.feed_name, value: f.feed_name })),
      );
      setFarmOptions(farms.map((f) => ({ label: f.name, value: f.id })));
    };

    fetchOptions();
  }, []);

  const fetchReport = async () => {
    const params = new URLSearchParams({
      farmId: selectedFarm?.value || "",
      feedName: selectedFeed?.value || "",
      dateFrom: dateFrom || "",
      dateTo: dateTo || "",
    });

    const res = await api.get(`/feed-report?${params.toString()}`);
    const data = res.data;
    setReportData(data);
  };

  return (
    <div>
      <h2>Feed Report</h2>

      <div className="d-flex gap-3 mb-3">
        <Select
          options={farmOptions}
          value={selectedFarm}
          onChange={setSelectedFarm}
          placeholder="Filter by Farm"
          isClearable
        />
        <Select
          options={feedOptions}
          value={selectedFeed}
          onChange={setSelectedFeed}
          placeholder="Filter by Feed"
          isClearable
        />
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
        />
        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
        />
        <button className="btn btn-primary" onClick={fetchReport}>
          Search
        </button>
      </div>

      <DataTable
        columns={[
          { name: "Feed Name", selector: (row) => row.feed_name },
          { name: "Total Used", selector: (row) => row.total_quantity_used },
          {
            name: "Total Restocked",
            selector: (row) => row.total_quantity_restocked,
          },
          { name: "Total Cost", selector: (row) => row.total_cost_spent },
          { name: "Avg Unit Cost", selector: (row) => row.avg_unit_cost },
          {
            name: "Stock Balance",
            selector: (row) => row.current_stock_balance,
          },
        ]}
        data={reportData}
        pagination
        highlightOnHover
      />
    </div>
  );
};

export default FeedReport;
